import React, { useState } from 'react';
import { MobileCard } from '.';
import {
  styled,
  ThemeProvider,
} from '@volkswagen-onehub/components-core';
import { TabsNavigation } from '.';
import { ModulProps } from 'src/feature-app/pages/CarouselPage';
import { useWindowHeight } from '@react-hook/window-size';
import { useFaContent } from 'src/feature-app/hooks';


interface styleProps {
  height?: number;
  themeColor?: string;
}

const TabsWrapper = styled.div<styleProps>`
  min-height: 100vh;
  overflow: hidden;
  position: relative;
  background: ${(props)=> props.themeColor === 'inverted' ? 'radial-gradient(circle at right center, rgb(0, 67, 122) 0%, rgb(0, 30, 80) 100%)' : 'transparent'} ;
`;
const BackgroundImage = styled.img<styleProps>`
  height: auto;
  min-height: 100vh;
  min-width: 100vw;
  width: auto;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
`;

const ContentWrapper = styled.div<styleProps>`
  position: ${(props)=> props.height < 500 ? 'relative' : 'absolute'};
  top: 0;
  left: 0;
  min-height: 400px;
`;

export const Tabs = (props: ModulProps ) => {
  const { carlinesWithOffers } = props;
  const faContent = useFaContent();

  const [ activeTab, setActiveTab ] = useState<number>(0);
  const height= useWindowHeight();


  return (
    <ThemeProvider theme={faContent.theme}>
      <TabsWrapper themeColor={faContent.theme}>
        {
          faContent.imageUrl && <BackgroundImage src={faContent.imageUrl} className='background-image' height={height}/>
        }
        
        <ContentWrapper className="outlet" height={height}>
          <MobileCard numberOfOffers={carlinesWithOffers.ofertas.length} offer={carlinesWithOffers.ofertas[activeTab]}/>
        </ContentWrapper>
        <TabsNavigation setActiveTab={setActiveTab} offers={carlinesWithOffers} activeTab={activeTab}  height={height}/>
      </TabsWrapper>
    </ThemeProvider>
  );
};

